import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowboardNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M24.068.791a5.338 5.338 0 00-7.42 2.624L14.147 9.3a58.77 58.77 0 01-4.766 8.961l-3.442 5.3a5.338 5.338 0 109.391 4.994l2.487-5.855a58.778 58.778 0 014.764-8.961l3.46-5.333A5.34 5.34 0 0024.068.791zm.589 6.721L21.2 12.845a60.464 60.464 0 00-4.9 9.213l-2.487 5.85a3.69 3.69 0 11-6.488-3.449l3.442-5.3a60.495 60.495 0 004.9-9.213l2.5-5.881a3.689 3.689 0 116.49 3.45z" />
        <path d="M14.734 19.026l-.564-.3a1.304 1.304 0 00-1.907 1.026 1.302 1.302 0 00.685 1.274l.565.3a1.302 1.302 0 101.221-2.3zm3.776-8.591h-.64a1.3 1.3 0 000 2.6h.64a1.3 1.3 0 000-2.6z" />
      </g>
    </svg>
  )
);
SvgSportsSnowboardNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowboardNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowboardNormalMedium;
